/** Width dưới ngưỡng này → mobile layout. Khớp Tailwind md. */
export const MOBILE_MAX_WIDTH = 768;

/**
 * Physical / device short-side under this → treat as phone even when the
 * browser requests "Desktop site" (layout viewport often ~980px).
 * Keep below iPad portrait (~768) so tablets stay width-based.
 */
export const PHONE_DEVICE_MAX = 768;

export function isTouchCapable(): boolean {
  if (typeof window === 'undefined') return false;
  if ((navigator.maxTouchPoints ?? 0) > 0) return true;
  try {
    return window.matchMedia('(pointer: coarse)').matches;
  } catch {
    return false;
  }
}

/**
 * True when layout looks "desktop-wide" but the device is still a phone.
 * Chrome Desktop site spoofs innerWidth (and sometimes screen.*) — prefer
 * max-device-width + outer box, then fall back to screen short-side.
 */
export function isPhoneWithDesktopSiteViewport(layoutWidth: number): boolean {
  if (typeof window === 'undefined' || typeof screen === 'undefined') return false;
  if (layoutWidth < MOBILE_MAX_WIDTH) return false;
  if (!isTouchCapable()) return false;

  try {
    // device-width ignores the spoofed layout viewport in most mobile browsers
    if (window.matchMedia(`(max-device-width: ${PHONE_DEVICE_MAX - 1}px)`).matches) {
      return true;
    }
  } catch {
    /* ignore */
  }

  // Chrome Android Desktop site: outer box often stays phone-sized
  const outerShort = Math.min(window.outerWidth || 0, window.outerHeight || 0);
  if (outerShort > 0 && outerShort < PHONE_DEVICE_MAX) return true;

  const screenShort = Math.min(screen.width || 0, screen.height || 0);
  if (screenShort > 0 && screenShort < PHONE_DEVICE_MAX) return true;

  return false;
}

export function readIsMobileLayout(): boolean {
  if (typeof window === 'undefined') return false;
  const width = window.innerWidth;
  return width < MOBILE_MAX_WIDTH || isPhoneWithDesktopSiteViewport(width);
}
